<template>
  <div class="addfinancialfirm">
    <div class="title">
      金融公司管理  <span>添加金融公司信息</span>
    </div>
    <div class="main">
      <div class="addFinancialfirmInfo">添加金融公司信息</div>
      <div class="financialfirmContent">
        <div class="financialfirmlist">
          <label for="financialfirmname">
            <span>*</span>金融公司名称
          </label>
          <el-input
            size="small"
            placeholder="请输入"
            v-model="financialfirmInfo.companyName"
          ></el-input>
        </div>
        <div class="financialfirmlist">
          <label for="financialfirmnum"><span>*</span>年利率</label>
          <el-input size="small" v-model="financialfirmInfo.interestRale" ></el-input>
          <span class="rate">利率为1以下的正浮点数，eg：0.23</span>
        </div>
        <div class="financialfirmlist">
          <label for="updateStatus">
            <span>*</span>设置为默认
          </label>
          <div class='versionRadio'>
            <el-radio v-model="financialfirmInfo.theDefault" label="1">是</el-radio>
            <el-radio v-model="financialfirmInfo.theDefault" label="0">否</el-radio>
          </div>
        </div>
        <div class="financialfirmlist">
          <label for="remark">备注</label>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="financialfirmInfo.remarks"
          ></el-input>
        </div>
        <div class="financialfirmBtn">
          <button
            class="save"
            @click="handleAddClick"
          >
            保存
          </button>
          <button
            @click="handleCancelClick"
            class="cancel"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addFinancialfirm, getChangeFinancialFirm, saveChangeFinancialFirm } from 'apis/index'
export default {
  name: 'addfinancialfirm',
  data () {
    return {
      id: '',
      financialfirmInfo: {
        companyName: '',
        interestRale: '',
        remarks: '',
        theDefault: '0'
      }
    }
  },
  methods: {
    getData (id) {
      getChangeFinancialFirm({
        bankCompanyId: id
      }).then(res => {
        if (res.data.code === 0) {
          this.financialfirmInfo = res.data.data.result
        }
      })
    },
    isIntNum (val) { // 正则匹配
      let regPos = /^[0]\d*\.\d*|0\.\d*[1-9]\d*$/ // 0以下浮点数
      if (regPos.test(val)) {
        return true
      } else {
        return false
      }
    },
    handleAddClick () { // 添加/保存
      if (!this.financialfirmInfo.companyName | !this.financialfirmInfo.interestRale) {
        this.$message({
          message: '*为必选内容',
          type: 'warning'
        })
      } else {
        if (this.isIntNum(this.financialfirmInfo.interestRale)) {
          if (this.id) {
            saveChangeFinancialFirm({ // 保存修改信息
              bankCompanyId: this.id,
              companyName: this.financialfirmInfo.companyName,
              interestRale: this.financialfirmInfo.interestRale,
              theDefault: this.financialfirmInfo.theDefault,
              remarks: this.financialfirmInfo.remarks
            }).then(res => {
              if (res.data.code === 0) {
                this.$router.push({path: '/manage/financialfirm'})
              }
            })
          } else {
            addFinancialfirm({ // 添加信息
              companyName: this.financialfirmInfo.companyName,
              interestRale: this.financialfirmInfo.interestRale,
              theDefault: this.financialfirmInfo.theDefault,
              remarks: this.financialfirmInfo.remarks
            }).then(res => {
              if (res.data.code === 0) {
                this.$router.push({path: '/manage/financialfirm'})
              }
            })
          }
        } else {
          this.$message({
            message: '利率为1以下的正浮点数',
            type: 'warning'
          })
        }
      }
    },
    handleCancelClick () {
      this.$router.push({path: '/manage/financialfirm'})
    }
  },
  mounted () {
    this.id = this.$route.query.item
    this.getData(this.id)
  }
}
</script>
<style lang="stylus">
.addfinancialfirm
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url(../../../assets/images/01/nav_arrow.png) no-repeat top 21px left 82px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addFinancialfirmInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url(../../../assets/images/03/add_icon.png) no-repeat center left 15px
    .financialfirmContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .financialfirmlist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .versionRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
        .rate
          position relative
          left 15px
          color #f66

      .financialfirmBtn
        margin-left 116px
        margin-top 150px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE

</style>
